import React, { useState } from "react";
import { Modal, Button as AntButton, Space, Typography, Segmented } from "antd";
import Helper from "utils/Helper";
import Iconify from "./Iconify";

const PreviewModal = ({ title, basePath, recordId, open, onClose }) => {
  const [previewLang, setPreviewLang] = useState("en");

  const baseUrl = (Helper.landingURL || "").replace(/\/+$/, "");
  const cleanPath = (basePath || "").replace(/^\/+|\/+$/g, "");
  const previewUrl = recordId
    ? `${baseUrl}/${cleanPath}/${recordId}?lang=${previewLang}`
    : null;

  return (
    <Modal
      title={
        <Space align="center" size={16}>
          <span>{title || "Preview"}</span>
          <Segmented
            value={previewLang}
            onChange={setPreviewLang}
            options={[
              { label: 'ID', value: 'id' },
              { label: 'EN', value: 'en' },
            ]}
          />
        </Space>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width="90%"
      centered
      destroyOnClose
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        {previewUrl && (
          <iframe
            key={previewLang}
            title={`${basePath}-${recordId}`}
            src={previewUrl}
            style={{
              width: "100%",
              height: "75vh",
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              background: "#fff",
              padding: "12px",
              boxSizing: "border-box",
            }}
          />
        )}
      </Space>
    </Modal>
  );
};

export default PreviewModal;
